import { render, staticRenderFns } from "./TestNotification.vue?vue&type=template&id=69f835e0&scoped=true"
import script from "./TestNotification.vue?vue&type=script&lang=js"
export * from "./TestNotification.vue?vue&type=script&lang=js"
import style0 from "./TestNotification.vue?vue&type=style&index=0&id=69f835e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f835e0",
  null
  
)

export default component.exports